import React from "react";
import { useNavigate } from "react-router-dom";

function ProfileIcon() {
  const navigate = useNavigate();
  const appUserName = localStorage.getItem("appUserName");
  const goToProfile = () => {
    navigate("/profile");
  };
  return (
    <div onClick={goToProfile} className="my-profile profile-icon absolute top-5 right-11">
      {/* {appUserName && <div className="avathar capitalize">{appUserName[0]}</div>}
      {!appUserName && <div className="login">Login</div>} */}
    </div>
  );
}

export default ProfileIcon;
